import { render } from "./company-lists.vue?vue&type=template&id=7f83470b&scoped=true&ts=true"
import script from "./company-lists.vue?vue&type=script&lang=ts"
export * from "./company-lists.vue?vue&type=script&lang=ts"

import "./company-lists.vue?vue&type=style&index=0&id=7f83470b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f83470b"]])

export default __exports__